// extracted by mini-css-extract-plugin
export default {"wrapper":"TgAuth_wrapper__ZM4Bj","tgEnabled":"TgAuth_tgEnabled__qT33j","tgDisabled":"TgAuth_tgDisabled__SQnIJ"};